import React, { useState } from "react";
import '../Dashboard.scss'
import CardSimple from "./DashboardCard/CardSimple";

// icons
import listIcon from '../../../assets/icons/list.png'
import qrIcon from '../../../assets/icons/qr.png'
import rutasIcon from '../../../assets/icons/rutas_caidas.png'
import comparationIcon from '../../../assets/icons/comparation.png'
import sensibilidadIcon from '../../../assets/icons/sensibilidad.png'
import checkListIcon from '../../../assets/icons/checkList.png'
import infoIcon from '../../../assets/icons/innfo.png'
import rotacionPersonalIcon from '../../../assets/icons/rotacionPersonal.png'

// modales

import ModalDataTable from "./ModalDataTable";
import ModalKmVsRutas from "./ModalKmVsRutas";
import ModalSencibilidadDelCliente from "./ModalSencibilidadDelCliente";
import ModalCheckListSumaDrivers from "./ModalCheckListSumaDrivers";
import ModalInformacionDeClientes from "./ModalInformacionDeClientes";
import ModalRotacionDeOperadores from "./ModalRotacionDeOperadores";
const Cards = ({
    dataEficiencia,
    params,
    conteoClientesBCorrectas,
    conteoKmVsRutas,
    nievelSatisfaccion,
    conteoSumaDrivers,
    conteoRotacion
}) => {
    const [bitacorasEci, setBitacorasEci] = useState(false)
    const [kmVsRuta, setKmVsRuta] = useState(false)
    const [sensibilidadCliente, setsensibilidadCliente] = useState(false)
    const [checkListSumaDrivers, setCheckListSumaDrivers] = useState(false)
    const [informcacionClientes, setInformcacionClientes] = useState(false)
    const [rotacionOperadores, setRotacionOperadores] = useState(false)
    return (
        <>
            <div className="contenedorSeccionCards">
                <CardSimple title="Eficiencia global" icon={listIcon} value={dataEficiencia?.EFICIENCIA_GLOBAL ? dataEficiencia?.EFICIENCIA_GLOBAL : '0'} />
                <CardSimple title="Rutas caídas" icon={rutasIcon} value={dataEficiencia?.RUTAS_CAIDAS} />
                <CardSimple onClick={() => { setBitacorasEci(true) }} title="Bitácoras hechas" icon={qrIcon} subTitle="bitácoras con registro de aforo" value={conteoClientesBCorrectas} />
                <CardSimple onClick={() => { setKmVsRuta(true) }} title="Kilometrajes VS Ruta" icon={comparationIcon} subTitle="bitácoras con registro de aforo" value={conteoKmVsRutas} />
                <CardSimple onClick={() => { setsensibilidadCliente(true) }} title="Sensibilidad del cliente" icon={sensibilidadIcon} subTitle="bitácoras con registro de aforo" value={<div style={{fontSize:"1.2rem"}}>{nievelSatisfaccion}</div>} />
                <CardSimple onClick={() => { setCheckListSumaDrivers(true) }} title="Checklist Sumadrivers" icon={checkListIcon} subTitle="bitácoras con registro de aforo" value={conteoSumaDrivers} />
                <CardSimple onClick={() => { setInformcacionClientes(true) }} title="Información de clientes" icon={infoIcon} subTitle="bitácoras con registro de aforo" value={'i'} />
                <CardSimple onClick={() => { setRotacionOperadores(true) }} title="Rotación de operadores" icon={rotacionPersonalIcon} subTitle="bitácoras con registro de aforo" value={conteoRotacion} />
            </div>
            <ModalDataTable title={"Bitácoras hechas con registro de aforo"} visible={bitacorasEci} onHide={() => { setBitacorasEci(false) }} params={params} />
            <ModalKmVsRutas title={"Kilometrajes VS Ruta"} visible={kmVsRuta} onHide={() => { setKmVsRuta(false) }} />
            <ModalSencibilidadDelCliente title={"Sensibilidad del cliente"} visible={sensibilidadCliente} onHide={() => { setsensibilidadCliente(false) }} />
            <ModalCheckListSumaDrivers title={"Checklist Sumadrivers"} visible={checkListSumaDrivers} onHide={() => { setCheckListSumaDrivers(false) }} params={params} />
            <ModalInformacionDeClientes title={"Información de clientes"} visible={informcacionClientes} onHide={() => { setInformcacionClientes(false) }} params={params} />
            <ModalRotacionDeOperadores title={"Rotación de operadores"} visible={rotacionOperadores} onHide={() => { setRotacionOperadores(false) }} params={params} />
        </>
    )
}
export default Cards